module.exports = __webpack_public_path__ + "img/hic-ovarian-cancer-female.dcaf0cb6.png";